<template>
  <div class="personal-center-container">
    <!-- 未购买 -->
    <div class="not-buy personal-center" v-if="buyType === '0'">
      <PersonalCardNot />
      <FreeStudy></FreeStudy>
      <FreeAd></FreeAd>
      <PersonalVideo title="联合会员介绍"></PersonalVideo>
    </div>
  
    <!-- 单独购买 -->
    <div class="single-buy personal-center" v-if="buyType === '1'">
      <PersonalCardSingle />
      <PersonalTable />
      <FreeAd></FreeAd>
      <PersonalVideo title="会员授权绑定指南"></PersonalVideo>
    </div>
  
    <!-- 联合购买 -->
    <div class="multi-buy personal-center" v-if="buyType === '2'">
      <PersonalCardMulti />
      <PersonalTable />
      <PersonalVideo title="会员授权绑定指南"></PersonalVideo>
    </div>
    <!-- <HDFFooter /> -->
    <HDFCopyright />
  </div>
</template>

<script setup>
import FreeStudy from '@/components/FreeStudy.vue'
import FreeAd from '@/components/FreeAd.vue'
import PersonalVideo from '@/components/PersonalVideo.vue'
// import HDFFooter from '@/components/HDFFooter.vue'
import PersonalCardNot from '@/components/PersonalCardNot.vue'
import PersonalCardSingle from '@/components/PersonalCardSingle.vue'
import PersonalCardMulti from '@/components/PersonalCardMulti.vue'
import HDFCopyright from '@/components/HDFCopyright.vue'
import PersonalTable from '@/components/PersonalTable.vue'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const buyType = ref('2')

onMounted(() => {
  if (!window.localStorage.getItem('token')) {
    router.push('/signIn')
  } else if (window.localStorage.getItem('token') === '13800000000') {
    buyType.value = '0'
  } else if (window.localStorage.getItem('token') === '13800000001') {
    buyType.value = '1'
  } else if (window.localStorage.getItem('token') === '13800000002') {
    buyType.value = '2'
  }
})
</script>

<style scoped>
.personal-center-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}
.personal-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  flex-grow: 1;
}
</style>
